import { render, staticRenderFns } from "./NpaPromotionHistoryDocs.vue?vue&type=template&id=c7fdbbd8&scoped=true"
import script from "./NpaPromotionHistoryDocs.vue?vue&type=script&lang=js"
export * from "./NpaPromotionHistoryDocs.vue?vue&type=script&lang=js"
import style0 from "./NpaPromotionHistoryDocs.vue?vue&type=style&index=0&id=c7fdbbd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fdbbd8",
  null
  
)

export default component.exports